import { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { ChevronDown, Search, CarFront } from 'react-bootstrap-icons';
import { toImageArray } from '../../../common/format';

// Dropdown for picking a car to add as an auction lot. Shows a photo, year,
// make and model for every car that is still available (not sold, not already
// on an auction). `cars` is the available list, `value` the selected car id.
const label = (c) => [c.year, c.mark, c.model].filter(Boolean).join(' ') || `#${c.id}`;
const thumbOf = (c) => toImageArray(c.images)[0];

const Thumb = ({ car }) => {
    const img = thumbOf(car);
    return (
        <span className="admin-carpicker-thumb" style={img ? { backgroundImage: `url('${img}')` } : {}}>
            {!img && <CarFront />}
        </span>
    );
};

const CarPicker = ({ cars = [], value, onChange, placeholder }) => {
    const [open, setOpen] = useState(false);
    const [q, setQ] = useState('');

    const selected = cars.find((c) => String(c.id) === String(value));
    const query = q.trim().toLowerCase();
    const filtered = query
        ? cars.filter((c) => `${label(c)} ${c.id} ${c.vin || ''}`.toLowerCase().includes(query))
        : cars;

    return (
        <div className="admin-carpicker">
            <button type="button" className={`admin-carpicker-trigger ${open ? 'is-open' : ''}`} onClick={() => setOpen((o) => !o)}>
                {selected ? (
                    <span className="admin-carpicker-sel">
                        <Thumb car={selected} />
                        <span className="admin-carpicker-text">
                            <strong>{label(selected)}</strong>
                            <span>#{selected.id}</span>
                        </span>
                    </span>
                ) : (
                    <span className="admin-carpicker-ph">{placeholder}</span>
                )}
                <ChevronDown className="admin-carpicker-caret" />
            </button>

            {open && (
                <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
                    <div className="admin-carpicker-menu">
                        <div className="admin-carpicker-search">
                            <Search />
                            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="ძებნა მარკით, მოდელით, ID-ით ან VIN-ით" />
                        </div>
                        <div className="admin-carpicker-list">
                            {filtered.length === 0 && (
                                <div className="admin-carpicker-empty">
                                    {cars.length === 0 ? 'ხელმისაწვდომი მანქანა არ არის' : 'მანქანა ვერ მოიძებნა'}
                                </div>
                            )}
                            {filtered.map((c) => (
                                <button
                                    key={c.id}
                                    type="button"
                                    className={`admin-carpicker-opt ${String(c.id) === String(value) ? 'is-sel' : ''}`}
                                    onClick={() => { onChange(c.id); setOpen(false); setQ(''); }}
                                >
                                    <Thumb car={c} />
                                    <span className="admin-carpicker-text">
                                        <strong>{label(c)}</strong>
                                        <span>#{c.id}{c.vin ? ` · ${c.vin}` : ''}{c.price ? ` · ${Number(c.price).toLocaleString()} ${c.currency || ''}` : ''}</span>
                                    </span>
                                </button>
                            ))}
                        </div>
                    </div>
                </OutsideClickHandler>
            )}
        </div>
    );
};

export default CarPicker;
